import { useHistory } from 'react-router';
import { History, LocationDescriptor, Path } from 'history';
import { setLangToLocationDescriptor } from 'srcJs/helpers/LanguageHelper';
import app from 'srcJs/App';

type historyPush = (
  locationDescriptor: LocationDescriptor<History.LocationState> | Path,
  state?: History.LocationState,
) => void;

const useHistoryPush = (): historyPush => {
  const { push } = useHistory();

  return (
    locationDescriptor: LocationDescriptor<History.LocationState> | Path,
    state?: History.LocationState,
  ): void => {
    const locationDescriptorNew = setLangToLocationDescriptor(locationDescriptor, app.getLang());
    if (typeof locationDescriptorNew === 'string') {
      push(locationDescriptorNew, state);
    } else {
      push(locationDescriptorNew);
    }
  };
};

export { useHistoryPush };
